import RecentPostsMobile from './recent-posts-mobile';
import RecentPostsDesktop from './recent-posts-desktop';
import forDevice from '../../../common/hoc/for-device';

export default forDevice(RecentPostsMobile, RecentPostsDesktop);
